import FieldIcon from "../../../../fields3/generic/icon/icon";
import FieldConfig from "../../../../fields3/proto/field-config";
import FieldProjectIcon_View from "./render/view";
import Project from "../../../../model2/project/project";
import {ProjectIconsOptionsList} from "../../../../gd/const/item-icon/project";
import {ProjectIconDictionary} from "../../../../gd/const/project";

export default class FieldProjectIcon extends FieldIcon {

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel          = "Icon";
        this.icon               = 'ii5-image';

        this.options            = ProjectIconsOptionsList


        this.renderComponents.view      = FieldProjectIcon_View

    }

    canEdit(model:Project):boolean {
        return model.acl.canChangeIcon
    }

    // return Icon
    getDisplayValue(value: any): string {
        return ProjectIconDictionary[value]
    }


}